import React from "react";
import Image, { ContentWrapper,RotateImg} from "./style";

const RotateImage = ({className , Imgsrc}) => {
  const data = Imgsrc;
  const addAllClasses = [" "];
  if (className) {
    addAllClasses.push(className);
  }
  return (
    <ContentWrapper>
      <RotateImg className={addAllClasses.join(" ")} src={data.img} alt=""></RotateImg>
    </ContentWrapper>
  );
};

export default RotateImage;